const UNITS = ['B', 'KB', 'MB', 'GB']
const STEP = 1024

// El backend manda size_bytes en null cuando no pudo medir el archivo: el
// documento puede sobrevivir al archivo en disco. La fila se muestra igual —es
// justamente la que conviene borrar—, con el peso en blanco.
export const UNKNOWN_SIZE = '—'

/**
 * Formatea un peso en bytes en la unidad que lo deja legible.
 * Devuelve UNKNOWN_SIZE cuando no hay valor que mostrar.
 */
export function formatFileSize(bytes) {
  if (typeof bytes !== 'number' || !isFinite(bytes) || bytes < 0) return UNKNOWN_SIZE

  let value = bytes
  let unit = 0
  while (value >= STEP && unit < UNITS.length - 1) {
    value /= STEP
    unit += 1
  }

  // Un decimal solo cuando aporta: "1,5 KB" sí, "2,0 KB" no.
  const rounded = Math.round(value * 10) / 10
  const text = Number.isInteger(rounded)
    ? String(rounded)
    : String(rounded).replace('.', ',')

  return `${text} ${UNITS[unit]}`
}
